import {Tag} from "types/Tag";
import {dateTime} from "services/date";

/**
 * Transform the given tag by deserializing object properties
 *
 * @internal
 * @param tag
 */
export default function deserializeTag(tag: any): Tag {
    tag.created_at = dateTime(tag.created_at)
    tag.updated_at = dateTime(tag.updated_at)

    return tag;
}